import axios from 'axios'
axios.defaults.timeout = 600000;  //超时响应
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; // 配置请求头（推荐）
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'; // 配置请求头
axios.defaults.baseURL = ''; //确认协议和地址
axios.defaults.withCredentials = true;   // axios 默认不发送cookie，需要全局设置true发送cookie

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
    console.log(token)
  }
  //在发送请求之前做某件事
  if (config.method === 'post') {
    config.data = config.data;
  }
  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  //对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  console.log(error)
  if (error.response.status === 401 || error.response.status === 403) {
    window.localStorage.removeItem('token');
    window.location.href = '/login?initUrl=/';
  } else {
    return Promise.reject(error.response);
  }
});

const doDownloadByPost = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {responseType: 'blob'})
      .then(response => { resolve(response); },
        err => {
          reject(err);
        })
      .catch((error) => {
        reject(error)
      })
  })
}
const doPost = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => { resolve(response); },
        err => {
          reject(err);
        })
      .catch((error) => {
        reject(error)
      })
  })
}

const doPut = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(response => { resolve(response); },
        err => {
          reject(err);
        })
      .catch((error) => {
        reject(error)
      })
  })
}

const doDelete = (url, params) => {
  return new Promise((resolve, reject) => {
    axios.delete(url, params)
      .then(response => { resolve(response); },
        err => {
          reject(err);
        })
      .catch((error) => {
        reject(error)
      })
  })
}
////返回一个Promise(发送get请求)
const doGet = (url, param, responseType = null) => {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: param, responseType: responseType })
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export {
  doGet,
  doPost,
  doPut,
  doDelete,
  doDownloadByPost
};